import React from "react";

const HTMLEditor = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            className="u_fill"
            d="M8.405 25.771h18.3V21.2l6.406 6.4-6.405 6.4v-4.571h-18.3V34L2 27.6l6.405-6.4v4.571zm10.98-20.114v16.457h-3.66V5.657H4.745V2h25.621v3.657h-10.98z"
            fill={fill}
        />
    </svg>
);

export default HTMLEditor;
